// 100k Gewinnspiel Badge: Delegation, damit auch per AJAX geladene Produktkarten funktionieren
document.addEventListener('click', (event) => {
  const btn = event.target.closest('.gw-info');
  const insidePop = event.target.closest('.gw-pop');

  document.querySelectorAll('.gw-badge-wrap').forEach((wrap) => {
    const pop = wrap.querySelector('.gw-pop');
    const info = wrap.querySelector('.gw-info');
    if (pop === insidePop || info === btn) return;
    pop.hidden = true;
    info.setAttribute('aria-expanded', 'false');
  });

  if (!btn) return;
  const pop = btn.closest('.gw-badge-wrap').querySelector('.gw-pop');
  pop.hidden = !pop.hidden;
  btn.setAttribute('aria-expanded', String(!pop.hidden));
});
